<template>
  <div class="message" v-loading="loading">
    <div>
      <!-- option -->
      <ul class="optionList clearfix">
        <li class="option-item">
          <span class="label">区域</span>
          <el-select v-model="regionValue" placeholder="请选择" multiple collapse-tags @change="selectRegions">
            <el-option v-for="item in regionOptions" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li class="option-item">
          <span class="label">发证状态</span>
          <el-select v-model="licenceStateVal" placeholder="请选择">
            <el-option v-for="item in licenceState" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li class="option-item">
          <span class="label">申请时间</span>
          <el-date-picker v-model="applyDate" type="daterange" unlink-panels format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          :picker-options="pickerOptions2">
          </el-date-picker>
        </li>
        <li class="option-item">
          <span class="label">排水户/项目名称</span>
          <el-input v-model="likeNameValue" placeholder="模糊查询"></el-input>
        </li>
        <li class="option-item">
          <el-button type="primary" @click="queryData">查询</el-button>
          <el-button type="primary" @click="toNewMessage" v-show="decidePower('排水户信息管理-编辑')">新建</el-button>
        </li>

      </ul>
      <!-- table -->
      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table :cell-style="cellStyle" :data="tableData" stripe style="width: 100%" :height="tableHeight"
                  :header-cell-style="{background:'#e2e7eb'}">
          <el-table-column prop="num" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="companyname" label="排水户名称" width="120">
          </el-table-column>
          <el-table-column prop="seweragetype" label="排水户类别" width="120">
          </el-table-column>
          <el-table-column prop="sewerageindustrytype" label="排水户行业性质" width="120">
          </el-table-column>
          <el-table-column prop="region" label="区域" width="120">
          </el-table-column>
          <el-table-column prop="projectname" label="项目名称" width="150">
          </el-table-column>
          <el-table-column prop="projectaddre" label="项目地址" width="150">
          </el-table-column>
          <el-table-column prop="surveynum" label="勘察编号">
          </el-table-column>
          <el-table-column width="100" prop="applydate" :formatter="dateFormat" label="申请时间">
          </el-table-column>
          <el-table-column prop="licensestate" label="许可证状态" :formatter='getStatusText' width="120">
          </el-table-column>
          <el-table-column prop="licensedate" :formatter="dateFormat" label="发证时间" width="100">
          </el-table-column>
          <el-table-column prop="expirationdate" :formatter="dateFormat" label="有效期" width="100">
          </el-table-column>
          <el-table-column prop="name" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click='handleToInfo(scope.row)'>详情</el-button>
              <el-button type="text" v-if='scope.row.licensestate != 5' size="small" @click='editToInfo(scope.row)'
                         v-show="decidePower('排水户信息管理-编辑')">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="block" style="text-align:right;margin-top: 20px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page.sync="currentPage" :page-sizes="[20, 50, 80, 100]" :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <iframe v-show="false" id="iframe1" frameborder=0 name="iframe1" scrolling=auto src=""></iframe>
  </div>
</template>
<script>
// import pagination from '@/common/pagination/pagination';
export default {
  name: 'MessageMain',
  data() {
    return {
      //加载图标
      loading: true,
      currentPage: 1,
      total: 0,
      pageSize: 20,
      // 统计分析申请日期选项
      pickerOptions2: {
        shortcuts: [{
          text: '最近一个月',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            // 本月第一天日期
            var begin = year + "-" + month + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            //判断如果当前月份小于3月
            if (month < 3) {
              var year1 = year - 1;
              var month1 = 12 + parseInt(month) - 2;
            } else {
              var year1 = year;
              var month1 = month - 2;
            }
            // 本月第一天日期
            var begin = year1 + "-" + month1 + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            //判断如果当前月份小于6月
            if (month < 6) {
              var year1 = year - 1;
              var month1 = 12 + parseInt(month) - 5;
              if (month1 < 10) {
                month1 = "0" + month1;
              }
            } else {
              var year1 = year;
              var month1 = month - 5;
            }
            // 本月第一天日期
            var begin = year1 + "-" + month1 + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }]
      },
      // 所属区域
      regionValue: [],
      regionValueD: [], //不可变
      regionsLength: 0, //全局集合长度
      regionsVariableLength: 0, //全局集合长度变量
      regionOptions: [],
      // 申请日期（默认为空）
      applyDate: [],
       // 所属大平台单位id
      platformCompanyId: '',
      // 模糊查询名称
      likeNameValue: '',
      // 许可证状态
      licenceStateVal: '-1',
      licenceState: [{
        label: '全部',
        value: '-1'
      }, {
        label: '未发证',
        value: '0'
      }, {
        label: '已发证',
        value: '1'
      }],
      optionsPlantInf: [], //水厂信息
      optionsStatus: [{
        id: '0',
        value: "全部"
      }, {
        id: '1',
        value: "未填报"
      }, {
        id: '2',
        value: "已填报"
      }], //状态信息
      value: '0', //select 值
      values: '0', //select 值
      dateVal: '', //日期 值
      //排水户数量
      companyNum: '',
      //申请数量
      applyNum: '',
      //许可证数量
      licenseNum: '',
      // 排水户数据列表数据
      tableData: [],
      //				tableHeight: window.innerHeight - 60 - 40 - 20 - 20 - 80 - 50 - 20,
      tableHeight: window.innerHeight - 60 - 40 - 20 - 20 - 150,
    }
  },
  components: {
    // pagination
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.tableHeight = window.innerHeight - 60 - 40 - 20 - 20 - 150,
        that.tableHeight = window.tableHeight
      })()
    }
    // 获取所属大平台单位id
    var companyInfo = sessionStorage.getItem('drainage-companyInfo');
    if (companyInfo) {
      this.platformCompanyId = JSON.parse(companyInfo).CompanyId;
    } else {
      this.$message({
        type: 'error',
        message: '登录信息过期，请重新登录'
      });
      this.$router.push({
        path: '/login'
      });
    }    
    this.getNowTime();
    this.regionOptions = this.filterRegion();
    this.regionsLength = this.regionOptions.length;
    this.regionsVariableLength = this.regionOptions.length;
    var i;
    for (i in this.regionOptions) {
      this.regionValue.push(this.regionOptions[i].value);
    }
    this.regionValueD = this.regionValue;
    //			this.regionValue = this.regionOptions[0].value;
    this.queryData();
  },
  methods: {
    //设置有效期过期对应的有效期单元格字体变红
    cellStyle({
                row,
                column,
                rowIndex,
                columnIndex
              }) {
      //				debugger
      if (row.expirationdate != null && row.expirationdate.time < new Date().getTime() && columnIndex === 11) { //指定坐标
        return 'color:red'
      } else {
        return ''
      }
    },
    //设置有效期过期所在行字体变红
    //			tableRowClassName({
    //				row,
    //				rowIndex
    //			}) {
    //				if(row.expirationdate != null && row.expirationdate.time < new Date().getTime()) {
    //					return 'outdate-row';
    //				}
    //				return '';
    //			},
    // 设置默认日期
    getNowTime() {
      var dateArray = this.getMonthFirsetLastDay();
      var startDay = this.time2YMD(new Date(dateArray[0]).getTime());
      var endDay = this.time2YMD(new Date(dateArray[1]).getTime());
      this.applyDate = [startDay, endDay];
    },
    //区域选项发生变化时执行此方法
    selectRegions(val) {
      if (val.length > 0) {
        //										debugger;
        //选择后集合不包括全选'-1'且选择后的长度等于原始长度减去1并且变量长度等于原始长度，说明第一次点击全选，应清空
        if (val.indexOf('全部') == -1 && this.regionsLength - 1 == val.length && this.regionsVariableLength == this.regionsLength) {
          this.regionValue = [];
        }
        //集合最后一项包含-1说明点击了全选按钮应对全选
        if (val.indexOf('全部') != -1 && '全部' == val[val.length - 1]) {
          this.regionValue = this.regionValueD;
        }
        //如果选择后当前选择为集合最大长度，并且不包含’-1‘，则说明选中了所有项则全选应自动选中
        if (val.indexOf('全部') == -1 && val.length == this.regionsLength - 1 && this.regionsVariableLength != this.regionsLength) {
          this.regionValue = this.regionValueD;
        }
        //如果包含'-1'并且长度小于等于集合的长度则把'-1'从集合中去掉
        if (val.indexOf('全部') != -1 && '全部' != val[val.length - 1] && val.length <= this.regionsLength - 1) {
          var arr = [];
          var x;
          for (x in val) {
            if ('全部' != val[x]) {
              arr.push(val[x]);
            }
          }
          this.regionValue = arr;
        }
        this.regionsVariableLength = this.regionValue.length;
      }
    },
    handleToInfo(valObj) {
      var companyId = valObj.comid;
      var projectId = valObj.projectid;
      this.$router.push({
        name: 'messageInfo',
        params: {
          companyId: companyId,
          projectId: projectId
        }
      });
    },
    editToInfo(valObj) {
      var companyId = valObj.comid;
      var projectId = valObj.projectid;
      this.$router.push({
        name: 'editMessage',
        params: {
          companyId: companyId,
          projectId: projectId
        }
      });
    },
    // 查询排水户数据列表
    queryData() {
      this.loading = true;
      this.tableData = [];
      // var path = 'http://127.0.0.1:8091/drainagesystem/sewerageUser/exportSewerageUserList2Excel/aaa';
      // var dd = document.getElementById('iframe1');
      // dd.setAttribute('src',path);
      var startDate = '';
      var endDate = '';
      if (this.applyDate && this.applyDate.length > 0) {
        startDate = this.applyDate[0];
        endDate = this.applyDate[1];
      }
      var arr = [];
      if (this.regionValue.indexOf('全部') != -1) {
        var x;
        for (x in this.regionOptions) {
          if ('全部' != this.regionOptions[x].value) {
            arr.push(this.regionOptions[x].value);
          }
        }
      } else {
        arr = this.regionValue;
      }
      this.$http.post(this.basePath + '/sewerageUser/findSewerageUserList/' 
                    + this.currentPage + '/' + this.pageSize, {
        //  参数
        platformCompanyId: this.platformCompanyId,
        likeName: this.likeNameValue,
        licenceState: this.licenceStateVal,
        applyDateStart: startDate,
        applyDateEnd: endDate,
        companyRegion: arr
      }).then((result) => {
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var pageObj = JSON.parse(result.data.data);
            this.total = pageObj.total;
            var dataList = pageObj.list;
            if (dataList.length > 0) {
              for (var i = 0; i < dataList.length; i++) {
                var dataObj = dataList[i];
                dataObj.num = (i + 1);
                this.tableData.push(dataObj);
              }
            }
          }
        } else {
          //						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }, (error) => {
        setTimeout(() => {
          this.loading = false;
        }, 300);
        console.log('获取单位信息异常');
      });
    },
    toNewMessage() {
      this.$router.push('/message/new')
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      } else {
        return this.time2YMD(date.time);
      }
    },
    handleSizeChange(val) {
      this.pageSize = Number(`${val}`);
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = Number(`${val}`);
      this.queryData();
    },
    // 获取状态文本（调用公共方法）
    getStatusText(row, column) {
      var text = this.getStatusTextMain(row.licensestate);
      return text;
    },
  }
}
</script>
<style lang="stylus" scoped>
  .message >>> .label {
    display: inline-block;
    font-size: 12px;
    color: #262626;
    margin-right: 10px;
    width: 90px
    line-height: 36px
  }

  .message >>> .el-input__inner {
    flex: 1;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #262626;
    border: 1px solid #D3D9DB;
    position: relative;
  }

  .message >>> .el-date-editor--daterange.el-input__inner {
    flex: 1;
    position: relative;
  }

  .message >>> .el-button--primary {
    border-color: #3E82F7;
  }

  .message >>> .el-button {
    font-size: 12px;
    border-radius: 2px;
  }

  .message >>> .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    flex: 1;
  }

  .message >>> .el-input {
    flex: 1;
  }

  .optionList {
    margin: 20px 0 20px 20px;
    display flex;
    .option-item {
      margin-right: 20px;
      flex 1;
      display flex;
      &:last-child {
        float: right;
      }
    }

  }

  .table-wrapper {
    margin: 0 20px;

    .el-table td,
    .el-table th {
      padding: 6px 0;
    }

    .el-table thead.is-group th {
      background: #fafafa;
    }

    .el-table td {
      border: none;
    }

    .el-table .cell {
      font-size: 12px;
    }

    .el-table thead {
      font-size: 12px;
    }

    .data-wrapper .table-wrapper .el-table .cell {
      color: #666;
    }

    .el-table th {
      background-color: #FAFAFA;
      border-right: 1px solid #ffffff;

      &:last-child {
        border-right: none;
      }
    }
  }

  .chart-wrapper {
    margin: 0 20px;
  }

  /*.el-table .outdate-row {
    color: red;
  }*/

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: oldlace !important;
  }

  .optionList .el-input__inner {
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/components/messageMain.vue